const paths = {
  EXPORT_PDF: "/export_template/pdf",
  EXPORT_EXCEL: "/export_template/excel",
  EXPORT_CSV: "/export_template/csv"
};

export default paths;